import apiClient from '../apiClient'

const noticeAPI = {
  // 공지사항 목록 조회 (최소한의 필드만)
  getNotices: (page = 1, limit = 5) =>
    apiClient.get('/notices', {
      params: {
        page,
        limit,
        fields: 'id,title,date,is_read,has_attachment', // 첨부파일 존재 여부 추가
      },
    }),

  // 공지사항 상세 조회 (전체 필드)
  getNoticeDetail: id =>
    apiClient.get(`/notices/${id}`, {
      params: {
        fields:
          'id,title,content,date,is_read,read_date,attachments,file_name,original_name',
      },
    }),

  // 공지사항 읽음 처리
  markAsRead: id => apiClient.post(`/notices/${id}/read`),
}

export default noticeAPI
